import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './helpers/auth.guard';
import { FrameComponent } from './pages/frame/frame.component';

const routes: Routes = [
  {
    path: ':tenant/login',
    pathMatch: 'full',
    loadChildren: () =>
      import('./pages/login/login.module').then(
        m => m.LoginModule
      )
  },
  {
    path: ':tenant/recover-password',
    pathMatch: 'full',
    loadChildren: () =>
      import('./pages/recover-password/recover-password.module').then(
        m => m.RecoverPasswordModule
      )
  },
  {
    path: ':tenant',
    component: FrameComponent,
    canActivate: [AuthGuard],
    children: [
      { 
        path: 'dashboard',
        loadChildren: () =>
          import('./pages/dashboard/dashboard.module').then(
            m => m.DashboardModule
          )
      },
      { 
        path: 'patients',
        loadChildren: () =>
          import('./pages/patients/patients.module').then(
            m => m.PatientsModule
          )
      },
      { 
        path: 'schedule',
        loadChildren: () =>
          import('./pages/schedule/schedule.module').then(
            m => m.ScheduleModule
          )
      },
      { 
        path: 'billing',
        loadChildren: () =>
          import('./pages/billing/billing.module').then(
            m => m.BillingModule
          )
      },
      { 
        path: 'quotes',
        loadChildren: () =>
          import('./pages/quotes/quotes.module').then(
            m => m.QuotesModule
          )
      },
      { 
        path: 'employees',
        loadChildren: () =>
          import('./pages/employees/employees.module').then(
            m => m.EmployeesModule
          )
      },
      { 
        path: 'medical-records',
        loadChildren: () =>
          import('./pages/medical-records/medical-records.module').then(
            m => m.MedicalRecordsModule
          )
      },
      { 
        path: 'products',
        loadChildren: () =>
          import('./pages/products/products.module').then(
            m => m.ProductsModule
          )
      },
      { 
        path: 'tenants',
        loadChildren: () =>
          import('./pages/tenants/tenants.module').then(
            m => m.TenantsModule
          )
      },
      { 
        path: 'timesheets',
        loadChildren: () =>
          import('./pages/timesheets/timesheets.module').then(
            m => m.TimesheetsModule
          )
      },
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
    ],
  },
  { path: '', redirectTo: 'benefit/login', pathMatch: 'full' },
  { path: '**', redirectTo: 'benefit/login', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
